import { gql } from '@apollo/client';

export const SIGN_IN = gql`
  query signin($login: String!, $password: String!) {
    signin(login: $login, password: $password) {
      Authorization
    }
  }
`;
